import { gateway } from "src/gateway";
import { FlowMobileSubscriptionSelfResponse, GetSubscriptionSelfParams } from "../interfaces/subscriptions.interfaces";

export const apiGetSubscriptionSelf = async ({
    skipPayPalFetch = true,
    section,
}: GetSubscriptionSelfParams): Promise<FlowMobileSubscriptionSelfResponse> => {
    const response = await gateway.get<FlowMobileSubscriptionSelfResponse>(
        'paypal/subscriptions-self',
        {
            params: {
                skipPayPalFetch,
                section,
            },
        },
    );

    return response.data;
};